import { useMemo } from "react";
import { DataTable } from "@/components/ui/data-table";
import type { CommissionTransaction } from "@/lib/commission.api";
import type { Party } from "@/lib/party.api";
import { createCommissionColumns } from "../commissionTableColumns";

interface CommissionsTableProps {
  commissions: CommissionTransaction[];
  parties: Record<number, Party>;
  loading: boolean;
  canDelete: boolean;
  deletingId: number | null;
  typeLabel: (code: string) => string;
  onSelect: (commission: CommissionTransaction) => void;
  onReload: () => void;
  onDelete: (id: number) => void;
}

export function CommissionsTable({
  commissions,
  parties,
  loading,
  canDelete,
  deletingId,
  typeLabel,
  onSelect,
  onReload,
  onDelete,
}: CommissionsTableProps) {
  const columns = useMemo(
    () =>
      createCommissionColumns({
        parties,
        typeLabel,
        canDelete,
        deletingId,
        onSelect,
        onReload,
        onDelete,
      }),
    [canDelete, deletingId, onDelete, onReload, onSelect, parties, typeLabel],
  );

  return (
    <DataTable
      columns={columns}
      data={commissions}
      loading={loading}
      emptyMessage="Aucune commission."
      onRowClick={onSelect}
      pageSize={10}
    />
  );
}
